export const userParser = ({
  administrativeRights,
  email,
  jobFunction,
  jobTitle,
  licencesAndRoles,
  phone,
  hasCofaceLicense,
}) => {
  return {
    administrativeRights,
    email,
    jobFunction,
    jobTitle,
    licencesAndRoles,
    phone,
    hasCofaceLicense,
  };
};
